import { ChartLayoutOptionsBuilder } from 'app/components/favourite-layout/favourite/chart-layout-options/chart-layout-options-builder';
import { ChartExportOptions, createDefaultChartExportOptions } from './chart-export';
import { ChartMiscOptions, createDefaultChartMiscOptions } from './chart-misc';
import { ChartLayoutConfig } from '../common/layout-config';

export class DefaultChartLayoutOptionsBuilder implements ChartLayoutOptionsBuilder {

  private config: ChartLayoutConfig;

  constructor(config: ChartLayoutConfig) {
    this.config = config;
  }

  public miscOptions: ChartMiscOptions = createDefaultChartMiscOptions();
  public exportOptions: ChartExportOptions = createDefaultChartExportOptions();

  public setOptions(options: Highcharts.Options) {
    this.setColors(options);
    this.setExport(options);
  }

  private setColors(options: Highcharts.Options) {
    const colors = this.miscOptions.colors(this.config);

    if (colors) {
      options.colors = colors;
    }
  }

  private setExport(options: Highcharts.Options) {
    if (this.exportOptions.isExportEnabled(this.config)) {
      this.exportOptions.addExportOptions(this.config, options);
      options.exporting.enabled = true;
    } else {
      options.exporting = { enabled: false };
    }
  }
}
